let durations: any = {
	1: 0.15,
	2: 0.2,
	3: 0.4,
	4: 0.6,
	5: 0.8,
	6: 1.2,
	7: 1.6,
	8: 2,
	9: 2.5,
	10: 3,
	11: 3.5,
	12: 4,
	13: 6,
	14: 8,
	15: 10,
	16: 12,
	17: 14,
	18: 16,
	19: 18,
	20: 20
};

durations.fastest = 0.1;
durations.faster = 0.2;
durations.fast = 0.4;
durations.normal = 0.6;
durations.slow = 0.8;
durations.slower = 1.2;
durations.slowest = 1.6;
durations.shortest = 2;
durations.shorter = 3;
durations.short = 4;
durations.long = 6;
durations.longer = 8;
durations.longest = 1;

export default durations;
